import { Navigate, Outlet, useLocation, useSearchParams } from "react-router-dom";

import { useAuthStore } from "@/client/stores/auth";

export const GuestGuard = () => {
  const isLoggedIn = useAuthStore((state) => !!state.user);
  const location = useLocation();

  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect") ?? "/dashboard";

  // 特殊处理Login页面，允许即使已登录也可以访问登录页面
  // 这里正是为了解决微信绑定页面必须在登录页面显示的问题
  const isLoginPage = location.pathname === "/auth/login";

  // 如果是登录页面，即使已登录也允许继续访问，让登录页面自己处理微信绑定逻辑
  if (isLoginPage) {
    console.log("在登录页，即使用户已登录也允许访问，以便显示微信绑定页面");
    return <Outlet />;
  }

  if (isLoggedIn) {
    console.log("用户已登录，导航到:", redirect);
    return <Navigate to={redirect} />;
  }

  return <Outlet />;
};
